var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.6956V7.69556L20 3.69556H4L2 7.69909V20.6956C2 21.2479 2.44772 21.6956 3 21.6956H21C21.5523 21.6956 22 21.2479 22 20.6956ZM4 9.69556H20V19.6956H4V9.69556ZM5.236 5.69556H18.764L19.764 7.69556H4.237L5.236 5.69556ZM15 11.6956H9V13.6956H15V11.6956Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.814986bd35e051835d3063e2daed62a1.svg";
export { ForwardRef as ReactComponent };